import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  draggableProductId: null,
  draggableProductImage: null,
  draggableInitialPosition: { x: 0, y: 0 },
  unityDraggableProductData: null, // we will pass this data to unity 
  openProductsAfterPlacement: true,
}


// @IMPORTANT -> it's also used for configurator
const curatorProductsSlicer = createSlice({
  name: "curatorProducts",
  initialState,
  reducers: {
    setDraggableProductImage: (state, { payload }) => {
      
      state.draggableProductId = payload.id;
      state.draggableProductImage = payload.image;
      state.draggableInitialPosition = {
        x: payload.x,
        y: payload.y,
      }
    },
    setUnityDraggableProductData: (state, { payload }) => {
      state.unityDraggableProductData = payload;
    },
    setOpenProductsAfterPlacement: (state, { payload }) => {
      state.openProductsAfterPlacement = payload;
    },
    resetDraggableProduct: (state, {payload}) => {
      state.draggableProductImage = initialState.draggableProductImage
      state.draggableInitialPosition = initialState.draggableInitialPosition
      state.unityDraggableProductData = initialState.unityDraggableProductData
    },
    resetDraggableProductId: (state, {payload}) => {
      state.draggableProductId = payload
    }
  },
});

export const {
  setDraggableProductImage,
  setUnityDraggableProductData,
  resetDraggableProduct,
  setOpenProductsAfterPlacement,
  resetDraggableProductId
} = curatorProductsSlicer.actions;
export const actions = curatorProductsSlicer.actions;

export const curatorProductsSelector = (state) => state.curatorProducts;
export const curatorProductsReducer = curatorProductsSlicer.reducer;
export default curatorProductsReducer;

export const selectOpenProductsAfterPlacement = (state) => state.curatorProducts.openProductsAfterPlacement
export const selectDraggableProductImage = (state) => state.curatorProducts.draggableProductImage
export const selectDraggableProductInitialPosition = (state) => state.curatorProducts.draggableInitialPosition
export const selectUnityDraggableProductData = (state) => state.curatorProducts.unityDraggableProductData;
export const selectDraggableProductId = (state) => state.curatorProducts.draggableProductId;